import { SearchNoResult } from 'components/NoResultsContent'

import styled from 'styled-components'

export const AudioNoResult = styled(SearchNoResult)`
  padding: 20px 16px 0;
  img {
    width: 120px;
    height: 100px;
    margin-bottom: 8px;
    object-fit: contain;
  }
`
